import { defineComponent, openBlock, createElementBlock, createVNode, unref, withCtx, createBlock, createCommentVNode, createTextVNode, toDisplayString } from "vue";
import { CdrButton } from "@rei/cedar";
import { CompassSpinner } from "@rei/spinner";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxAddToCart",
  props: {
    id: {
      default: ""
    },
    cartLoadState: {
      type: Boolean
    },
    dataCnstrcBtn: {
      default: null
    },
    isPreorder: {
      type: Boolean
    },
    price: {},
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["addToCart"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [createVNode(unref(CdrButton), {
        id: _ctx.id,
        "data-cnstrc-btn": _ctx.dataCnstrcBtn,
        "data-ui": "product-buygrid-add2cart",
        "full-width": true,
        "aria-haspopup": "dialog",
        disabled: _ctx.isDisabled,
        onClick: _cache[0] || (_cache[0] = () => _ctx.$emit("addToCart", null))
      }, {
        default: withCtx(() => [_ctx.cartLoadState ? (openBlock(), createBlock(unref(CompassSpinner), {
          key: 0,
          class: "add-to-cart-button__spinner"
        })) : createCommentVNode("", true), createTextVNode(" " + toDisplayString(_ctx.isPreorder ? "Pre-order" : "Add to cart") + toDisplayString(_ctx.price ? `—$${_ctx.price}` : ""), 1)]),
        _: 1
      }, 8, ["id", "data-cnstrc-btn", "disabled"])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxAddToCart2.mjs.map
